import React, { useState } from "react";
import * as S from "./JourneyPhaseBlock.style";
import JourneyMilestone from "../journeyMilestone/JourneyMilestone";
import Popup from "reactjs-popup";
import FlorenzSelect from "../../../../florenzComponents/florenzSelect";

const defaultAvatar = "https://i.pravatar.cc/150?img=1"; // Mock avatar for "Está aquí"

const JourneyPhaseBlock = ({ block }) => {
  const [selectedCycle, setSelectedCycle] = useState(block.selectedCycle);

  return (
    <S.Container locked={block.status === "locked"}>
      <div className="block-header">
        <div className="header-left">
          {block.type === "cycle" ? (
            <div className="cycle-selector">
              <FlorenzSelect
                placeholder={"Ciclo 4"}
                label={"Ciclo de control actual"}
                xsSize={true}
                forWhiteBackgroud={false}
                // items={
                //   processTypes?.process?.map((item) => ({
                //     value: item.id,
                //     text: P.dataTranslation(item.processName, language),
                //     img: item.img
                //   })) || []
                // }
                // value={filterProgram}
              />
              {block.status === "locked" && (
                <div className="status-text">{block.cycleStatusText}</div>
              )}
            </div>
          ) : (
            <div className="title">{block.title}</div>
          )}

          <div className="date-controls">
            {block.dateText || block.date} 
            {block.status !== "locked" && <span className="action-text">Cambiar fecha</span>}
            {/* {block.type === "cycle" && <span className="action-text"> | Ver ciclo actual</span>} */}
            {/* {block.type === "cycle" && <span className="action-text"> | crear nuevo ciclo</span>} */}
          </div>

          {block.status === "locked" && (  
            <div className="subtitle">{"Para llegara este hito el paciente debe finalizar el anterior"}</div>
          )}
        </div>

        <div className="header-right">
          {block.status === "current" && (
            <div className="current-badge">
              Está aquí <img src={defaultAvatar} alt="avatar" className="avatar" />
            </div>
          )}
          {block.status === "completed" && (
            <div className="completed-badge">
              <i className="icon zaia-i-check-1" /> Completado
            </div>
          )}
          {block.status === "locked" && (
            <div className="locked-badge">
              <i className="icon zaia-i-locked" /> No disponible aun
            </div>
          )}
        </div>
      </div>

      <div className="milestones-list">
        {block.milestones.map(m => (
          <JourneyMilestone key={m.id} milestone={m} />
        ))}
      </div>
    </S.Container>
  );
};

export default JourneyPhaseBlock;
